import React, { useEffect, useState } from 'react';
import type { i18n } from 'i18next';
import { configurei18n } from './init-i18next';
import { Loading } from '../../components/common/Loading';

export const LanguageProvider: React.FC<
  React.PropsWithChildren<{ init?: (translation: i18n) => void }>
> = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    configurei18n(props.init).finally(() => setIsLoaded(true));
  }, []);
  if (!isLoaded) return <Loading loading={true} />;
  return props.children;
};
